if (!customElements.get('product-list')) {
  function customSort(arr) {
    return arr.sort((a, b) => {
        if (typeof a === 'number' && typeof b === 'number') {
            return a - b; // Numerical sort
        } else if (typeof a === 'string' && typeof b === 'string') {
            return a.localeCompare(b); // Alphabetical sort
        } else if (typeof a === 'number') {
            return -1; // Numbers come before strings
        } else {
            return 1; // Strings come after numbers
        }
    });
  }
  
  window.addEventListener('beforeunload', () => {   
    sessionStorage.setItem('scrollPosition', window.scrollY); 
    sessionStorage.setItem('collectionName', window.location.pathname);
  });
  
  
  window.addEventListener('load', () => {   
    const scrollPosition = sessionStorage.getItem('scrollPosition');   
    const collectionName = sessionStorage.getItem('collectionName');

    if (window.location.pathname !== collectionName) {
      sessionStorage.removeItem('scrollPosition');
      sessionStorage.removeItem('collectionName');

      return;
    }

    if (scrollPosition) {     
      window.scrollTo(0, parseInt(scrollPosition, 10));     
      sessionStorage.removeItem('scrollPosition');   
      sessionStorage.removeItem('collectionName');
    } 
  });
  class ProductList extends HTMLElement {
    constructor() {
      super();
      this.algoliaClient = false;
      this.currentIndex = 'shopify_ics_products';
      this.productsPerPage = 36;
      this.totalProductsShown = 0;
      this.page = 0;
      this.appliedFilters = '';
      this.query = '';
      this.queryID = '';
      this.collectionHandle = this.dataset.collectionHandle;
      this.shop = this.dataset.shop;
      this.token = this.dataset.token;
      this.offset = 0;
      this.tagsToExcludeFromResults = [
        'base-product', 
        'hide-product', 
        'team-logo',
        'tapcart_exclusive'
      ];
      this.sizeOrder = [
        'osf',
        'oss',
        'xs',
        's',
        'm',
        'l',
        'xl',
        '2x',
        'wmn',
        'yth',
        'tod',
        'inf',
        'kid',
      ];

      this.facetsOrder = [
        'named_tags.league',
        'named_tags.team',
        'named_tags.driver',
        'named_tags.breed',
        'named_tags.gender',
        'named_tags.style',
        'options.size',
      ];

      this.facetPrefixesExcludedFromDisplay = [ // Partial or full strings
        
      ];
      this.facetsExcludedFromDisplay = [ // Full strings
        'collections',
        'named_tags.filter'
      ];
      this.facetsValuesExcludedFromDisplay = { // Individual options in a facet
        'named_tags.league': [
          'dogs',
          'classics',
          'blanks',
          'misc',
          'oht',
          'resort',
          'ims',
        ],
        'named_tags.team': [
          'blank',
          'summer icons',
          'summer-icons',
          'corgi',
          'corgi butt',
          'corgi-butt',
          'hilton head sc',
          'hilton-head-sc',
          'cape cod ma',
          'cape-cod-ma',
          'nascar',
          'joey logano',
          'joey-logano',
          'nfl superbowl',
          'nfl-superbowl',
          'wedding',
        ],
        'named_tags.style': [
          `BASE-RUNNER-ICON`,
          `BEST SELLERS`,
          `BEST-SELLERS`,
          `best-sellers`,
          `BLANKS`,
          `CARHARTT`,
          `CITIES`,
          `CLASSICS`,
          `COLOR-CLEAN-UP`,
          `CORDUROY`,
          `CROPPED`,
          `CROPPED-TEE`,
          `DOGS`,
          `FALL EDIT`,
          `NETMINDER`,
          `NEW-ARRIVALS`,
          `new-arrivals`,
          `NEW-BALANCE`,
          `RETRO LOGOS`,
          `SHORTSTOP-HOOD`,
          `STONEY-CLOVER`,
          `TEES`,
          `TRENDING TEAMS`,
          `TRENDING-TEAMS`,
          `TWO-TONE`,
          `WOMENS`,
          `WOMENS TRENDING`,
          `WOMEN'S NEW ARRIVALS`,
        ]
      };
      this.labelOverrides = new Map([
        ['osf', 'ONE SIZE FITS ALL'],
        ['oss', 'ONE SIZE STRETCH'],
        ['wmn', 'WOMEN'],
        ['tod', 'TODDLER'],
        ['yth', 'YOUTH'],
        ['inf', 'INFANT'],
        ['driver', 'NASCAR Driver'],
        ['breed', 'Dog Breed'],
        ['featured collections', 'Collections'],
      ]);
    }
    
    connectedCallback() {
      this.init();
      this.initBannerDebugPanel();
      const searchParams = new URLSearchParams(window.location.search);
      
      ['change', 'click'].forEach((eventType) => {
        window.addEventListener(eventType, e => {
          const actionEl = e.target.closest('[data-filter-action]');
          if (!actionEl) return;
          
          const {
            filterAction,
            page,
            removeValue,
            category
          } = actionEl.dataset;
          
          switch (filterAction) {
            case 'algolia-filter-change':
              this.appliedFilters = this.buildFilterString();
              this.totalProductsShown = 0;
              this.page = 0;

              this.fetchFilteredResults(true, true, true);
              searchParams.set('filters', encodeURI(this.appliedFilters));
              
              history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
            break;
              
            case 'algolia-sort':
              const sortValue = actionEl.value;
              if (!sortValue || sortValue === this.currentIndex) return;
              searchParams.set('index', sortValue);
              this.currentIndex = sortValue;
              this.page = 0;
              this.fetchFilteredResults(false, true, true);

              history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
            break;
            
            case 'remove-algolia-filter': {
              const filterInput = document.querySelector(`[data-algolia-filter-group="${category}"] input[data-filter-action="algolia-filter-change"][value="${removeValue}"]:checked`);
              if (filterInput) {
                filterInput.checked = false;
                this.appliedFilters = this.buildFilterString();
                if (filterInput.closest('[data-team-picker-group]')) {
                  this._syncTeamPickerUI(this._getActiveTeamHandles());
                }
              } else {
                // Drawer closed — strip value directly from current filter string
                const current = decodeURI(searchParams.get('filters') || '');
                const stripped = current
                  .replace(new RegExp(`\\s*OR\\s*${category}:"${removeValue}"`, 'g'), '')
                  .replace(new RegExp(`${category}:"${removeValue}"\\s*OR\\s*`, 'g'), '')
                  .replace(new RegExp(`\\(?${category}:"${removeValue}"\\)?`, 'g'), '')
                  .replace(/\(\s*\)/g, '')
                  .replace(/\s+AND\s+AND\s+/g, ' AND ')
                  .replace(/^\s*AND\s+|\s+AND\s*$/g, '')
                  .trim();
                this.appliedFilters = stripped;
              }
              this.totalProductsShown = 0;
              this.page = 0;
              this.fetchFilteredResults(true, true, true);
              searchParams.set('filters', encodeURI(this.appliedFilters));
              history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
            } break;
            
            case 'remove-all-algolia-filter':
              window.location = window.location.href.split('?')[0];
            break;
              
            case 'quick-filter-clear':
              this.querySelectorAll('input[name="quick-filters"]').forEach(r => r.checked = false);
              this.appliedFilters = this.buildFilterString();
              this.totalProductsShown = 0;
              this.page = 0;
              this.fetchFilteredResults(true, true, true);
              searchParams.set('filters', encodeURI(this.appliedFilters));
              history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
            break;

            case 'pagination-next':
              this.paginate(page);
            break;
            
            case 'open-filters':
              document.querySelector('[data-filters-drawer]')?.classList.toggle('active');
              document.querySelector('.js-filter-overlay.filter__overlay')?.classList.toggle('open');
            break;
            default: break;
          }
        });
      });

      // Mobile grid view toggle — initial class set by Liquid via mobile_grid_columns setting
      if (!this.classList.contains('mobile-grid-1') && !this.classList.contains('mobile-grid-2')) {
        this.classList.add('mobile-grid-2');
      }
      this.addEventListener('click', e => {
        const btn = e.target.closest('[data-grid-view]');
        if (!btn) return;
        this.classList.remove('mobile-grid-1', 'mobile-grid-2');
        this.classList.add(`mobile-grid-${btn.dataset.gridView}`);
      });

      // Team search
      this._teamSearchTerm = '';
      document.addEventListener('input', e => {
        const input = e.target.closest('[data-team-search]');
        if (!input) return;
        this._teamSearchTerm = input.value.toLowerCase();
        this._applyTeamSearch();
        const clear = input.parentElement.querySelector('[data-team-search-clear]');
        const searchIcon = input.parentElement.querySelector('[data-team-search-icon]');
        if (clear) clear.classList.toggle('hidden', !input.value);
        if (searchIcon) searchIcon.classList.toggle('hidden', !!input.value);
      });
      document.addEventListener('click', e => {
        const btn = e.target.closest('[data-team-search-clear]');
        if (!btn) return;
        const input = btn.parentElement.querySelector('[data-team-search]');
        if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); }
        btn.classList.add('hidden');
        btn.parentElement.querySelector('[data-team-search-icon]')?.classList.remove('hidden');
      });

      window.addEventListener('click', e => {
        if (e.target.closest('[data-modal-id="filters-drawer"]') && this._lastFacets) {
          this.loadFilterLogos().then(() => {
            setTimeout(() => {
              this.renderFilters(this._lastFacets);
              const sortEl = document.querySelector('[data-filter-action="algolia-sort"]');
              if (sortEl) sortEl.value = this._initialSortIndex ?? this.currentIndex;
              this._initialSortIndex = null;
              this.hydrateLogos();
            }, 20);
          });
        }
        if (e.target.closest('[data-modal-id="teams-drawer"]')) {
          this.loadFilterLogos().then(() => {
            setTimeout(() => { this.renderTeamsDrawer(this._lastFacets ?? {}); }, 20);
          });
        }
        // My-team button — toggles that team in/out of multi-selection
        const myTeamBtn = e.target.closest('[data-my-team-btn]');
        if (myTeamBtn) {
          const handle  = myTeamBtn.dataset.teamHandle;
          const current = new Set(this._getActiveTeamHandles());
          current.has(handle) ? current.delete(handle) : current.add(handle);
          this.setTeamPickerFilter([...current]);
        }
      });

      // Teams drawer: checkbox change
      document.addEventListener('change', e => {
        const cb = e.target.closest('[data-teams-drawer-cb]');
        if (!cb) return;
        const checked = [...document.querySelectorAll('[data-teams-drawer-cb]:checked')].map(i => i.value);
        this.setTeamPickerFilter(checked);
      });

      // Teams drawer: search
      document.addEventListener('input', e => {
        const input = e.target.closest('[data-teams-drawer-search]');
        if (!input) return;
        const term = input.value.toLowerCase();
        const list = document.querySelector('[data-collection-teams-list]');
        let anyVisible = false;
        list?.querySelectorAll('li:not([data-teams-drawer-empty])').forEach(li => {
          const label = li.querySelector('label[data-team-label]')?.dataset.teamLabel ?? '';
          const visible = !term || label.toLowerCase().includes(term);
          li.hidden = !visible;
          if (visible) anyVisible = true;
        });
        let emptyEl = list?.querySelector('[data-teams-drawer-empty]');
        if (list && !anyVisible && term) {
          if (!emptyEl) {
            emptyEl = document.createElement('li');
            emptyEl.dataset.teamsDrawerEmpty = '';
            emptyEl.className = 'text-xs text-dove-grey py-4 text-center';
            emptyEl.textContent = 'No teams match your search';
            list.appendChild(emptyEl);
          }
          emptyEl.hidden = false;
        } else if (emptyEl) {
          emptyEl.hidden = true;
        }
        const clear = input.parentElement.querySelector('[data-teams-drawer-clear]');
        const searchIcon = input.parentElement.querySelector('[data-teams-search-icon]');
        if (clear) clear.classList.toggle('hidden', !input.value);
        if (searchIcon) searchIcon.classList.toggle('hidden', !!input.value);
      });
      document.addEventListener('click', e => {
        const btn = e.target.closest('[data-teams-drawer-clear]');
        if (!btn) return;
        const input = btn.parentElement.querySelector('[data-teams-drawer-search]');
        if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); }
        btn.classList.add('hidden');
        btn.parentElement.querySelector('[data-teams-search-icon]')?.classList.remove('hidden');
      });
      document.addEventListener('click', e => {
        if (!e.target.closest('[data-teams-clear-all]')) return;
        this.setTeamPickerFilter([]);
        document.querySelectorAll('[data-teams-drawer-cb]').forEach(cb => { cb.checked = false; });
      });

      // Re-insert in-grid tiles when crossing 768px breakpoint
      this._lastInGridMobile = window.innerWidth < 768;
      let _inGridResizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(_inGridResizeTimer);
        _inGridResizeTimer = setTimeout(() => {
          const isMobile = window.innerWidth < 768;
          if (isMobile !== this._lastInGridMobile) {
            this._lastInGridMobile = isMobile;
            this.reinsertInGridTiles();
          }
        }, 150);
      });

      this.addEventListener('click', e => {
        const btn = e.target.closest('[data-quick-type]');
        if (!btn) return;

        const value = btn.dataset.quickType;
        this.querySelectorAll('[data-quick-type]').forEach(el => el.classList.remove('active'));
        btn.classList.add('active');

        const targetCheckbox = document.querySelector(`[data-algolia-filter-group="named_tags.type"] input[value="${value}"]`);
        if (targetCheckbox && !targetCheckbox.checked) {
          targetCheckbox.click();
        }
      });

    }
    
    init() {
      const searchParams = new URLSearchParams(window.location.search);
      const initialFilterString = searchParams.get('filters') ? decodeURI(searchParams.get('filters')) : false;
      const initialIndex = searchParams.get('index') ? decodeURI(searchParams.get('index')) : false;
      this.query = searchParams.get('q') ? decodeURI(searchParams.get('q')) : '';
      
      if (initialIndex) {
        this._initialSortIndex = initialIndex;
        this.currentIndex = initialIndex;
      }
      
      this.collectionHandle = this.dataset.collectionHandle;
      this.shop = this.dataset.shop;
      this.token = this.dataset.token;
      this.customerId = this.dataset.customerId || false;
      this.appliedFilters = initialFilterString || this.buildFilterString();
      this.algoliaClient = window["algoliasearch/lite"].liteClient(this.dataset.appId, this.dataset.apiKey);

      requestAnimationFrame(() => this._syncFinderSelection());
      this.setInitialPagination();
    }
    
    setInitialPagination() {
      const searchParams = new URLSearchParams(window.location.search);
      const page = Number(searchParams.get('page')) || 0;
      this.page = page;
    
      const loadPages = async () => {
        for (let i = 0; i <= page; i++) {
          this.page = i;
          await this.fetchFilteredResults(i === 0, true, i === 0);
        }
      };
      loadPages();
    }
        
    buildBaseFilter() {
      let f = this.collectionHandle && this.collectionHandle !== 'all'
        ? `collections:${this.collectionHandle}`
        : '';
      const excluded = this.tagsToExcludeFromResults.map(t => `NOT tags:${t}`).join(' AND ');
      return f ? `${f} AND ${excluded}` : excluded;
    }

    async fetchFilteredResults(filters = true, products = true, replace = true) {
      const facetList = [
        'collections',
        'named_tags.gender',
        'named_tags.color-group',
        'named_tags.fit',
        'named_tags.league',
        'named_tags.style',
        'named_tags.team',
        'named_tags.type',
        'named_tags.brim',
        'named_tags.breed',
        'named_tags.driver',
        'named_tags.closure',
        'named_tags.filter',
        'options.size'
      ];
      const favorites = (this.dataset.favoriteTeams || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .map(s => s.replace(/^fav_team-/i, ''))
        .map(s => s.replace(/\s+/g, '-').toUpperCase());

      const hasFavorites = favorites.length > 0;
      const optionalFilters = [
        favorites.map((facet, i) => {
          return `named_tags.team:${facet}<score=${2500}>`;
        })
      ];

      await this.algoliaClient.search({
        requests: [
          {
            indexName: this.currentIndex,
            clickAnalytics: true,
            facets: facetList,
            ...(hasFavorites
              ? { enableRules: false, enableReRanking: false, optionalFilters, sumOrFiltersScores: true }
              : { ruleContexts: [`plp-${this.collectionHandle}`] }
            ),
            filters: this.appliedFilters,
            length: this.productsPerPage,
            offset: Math.max((this.productsPerPage * this.page) - this.offset, 0),
            query: this.query,
            getRankingInfo: true,
            ...(window.getAlgoliaUserToken?.() ? { userToken: window.getAlgoliaUserToken() } : {})
          }
        ]
      }).then((res) => {
        if (res.results[0].userData && res.results[0].userData[0].redirect) {
          window.location.replace(res.results[0].userData[0].redirect);
          return;
        }
        
        window.dispatchEvent(new CustomEvent('algolia:setData', { 
          detail: { 
            queryID: res.results[0]?.queryID,
            index: this.currentIndex
          } 
        }));
        
        this.filterProductFinder(res.results[0]?.facets || {});
        this.offset = 0;
        const totalResults = res.results[0].nbHits;
        this.queryID = res.results[0].queryID;

        if (filters) {
          const facets = res?.results?.[0]?.facets ?? {};
          this._lastFacets = facets;
          window.dispatchEvent(new CustomEvent('algolia:filtersViewed', {
            detail: { filters: facets }
          }));
          const filterDrawerOpen = !!document.querySelector('[data-modal-content="filters-drawer"].modal-visible');
          if (filterDrawerOpen) this.renderFilters(facets);
        }
        this.renderFilterRemovalButtons();
        if (products) {
          const algoliasBanners = this.dataset.algoliaBanners !== 'false'
            ? (res?.results?.[0]?.userData?.[0]?.banners || [])
            : [];
          this.renderProducts(res?.results?.[0]?.hits, replace, algoliasBanners.length ? algoliasBanners : false);
        }
                
        if (((this.page + 1) * this.productsPerPage) >= totalResults) {
          this.classList.add('fully-loaded');
        } else {
          this.classList.remove('fully-loaded');
        }
        
        if (this.querySelector('[data-total-products]')) {
          this.querySelectorAll('[data-total-products]').forEach(el => {
            el.innerText = totalResults;

            if (totalResults === 0) {
              document.querySelectorAll('[data-no-results]').forEach(el => {
                el.style.display = "block";
              })
            }
          });
        }
      });
    }
    
    buildFilterString() {
      let filterString = this.collectionHandle && this.collectionHandle != 'all' ? `collections:${this.collectionHandle}` : '';
              
      const appliedFilters = [...document.querySelectorAll('[data-algolia-filter-group]')].map((filterGroup) => {
        const groupName = filterGroup.dataset.algoliaFilterGroup;
        const appliedValues = [...filterGroup.querySelectorAll('input[data-filter-action="algolia-filter-change"]:checked')]
          .filter(filter => !!filter.value)
          .map(({ value, dataset: { additionalFilters, multiValue } }) => {
            if (multiValue) {
              return (`${value.split(',').map(thisValue => `${groupName}:"${thisValue}"`).join(' OR ')}`)
            }
            if (additionalFilters) {
              return (`${groupName}:"${value}" OR ${additionalFilters}`)
            }
            
            return (`${groupName}:"${value}"`);
          }).join(' OR ')
            
        if (!appliedValues.length) return;
        
        return `(${appliedValues})`;
      }).filter((x) => !!x).join(' AND ').toString();
      
      const excludedTags = this.tagsToExcludeFromResults.map(tag => `NOT tags:${tag}`).join(' AND ');

      if (appliedFilters.length) {
        filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ' AND ' : ''}${appliedFilters} AND ${excludedTags}`);
      } else {
        filterString = filterString.concat(`${this.collectionHandle && this.collectionHandle != 'all' ? ' AND ' : ''}${excludedTags}`);
      }
              
      return filterString;
    }
    
    _syncTeamPickerUI(handles) {
      const activeSet = new Set(Array.isArray(handles) ? handles : handles ? [handles] : []);
      const myBtn = document.querySelector('[data-my-team-btn]');
      if (myBtn) {
        const isActive = activeSet.has(myBtn.dataset.teamHandle);
        myBtn.toggleAttribute('data-active', isActive);
      }
      // Sync checkboxes if drawer is currently open
      document.querySelectorAll('[data-collection-teams-list] input[data-teams-drawer-cb]').forEach(cb => {
        cb.checked = activeSet.has(cb.value);
      });
    }

    setTeamPickerFilter(handles) {
      const activeSet = new Set(Array.isArray(handles) ? handles : handles ? [handles] : []);
      const group = document.querySelector('[data-team-picker-group]');
      if (!group) return;

      group.innerHTML = '';
      activeSet.forEach(handle => {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.checked = true;
        input.value = handle;
        input.dataset.filterAction = 'algolia-filter-change';
        input.dataset.filter = `named_tags.team:${handle}`;
        group.appendChild(input);
      });

      const searchParams = new URLSearchParams(window.location.search);
      this.appliedFilters = this.buildFilterString();
      this.totalProductsShown = 0;
      this.page = 0;
      searchParams.set('filters', encodeURI(this.appliedFilters));
      history.replaceState('', '', `?${searchParams.toString()}`);
      this.fetchFilteredResults(true, true, true);

      this._syncTeamPickerUI([...activeSet]);
    }

    _getActiveTeamHandles() {
      const sources = [
        this.appliedFilters || '',
        decodeURI(new URLSearchParams(window.location.search).get('filters') || '')
      ];
      const toHandle = v => v.toLowerCase().replaceAll(' ', '-');
      for (const str of sources) {
        const matches = [...str.matchAll(/named_tags\.team:"([^"]+)"/g)];
        if (matches.length) return matches.map(m => toHandle(m[1]));
      }
      return [...document.querySelectorAll('[data-team-picker-group] input:checked')].map(i => i.value);
    }

    renderTeamsDrawer(facets) {
      const list = document.querySelector('[data-collection-teams-list]');
      if (!list) return;

      const facetTeams = facets?.['named_tags.team'] ?? {};
      const logoTeams  = window.filterLogos?.team
        ? Object.fromEntries(Object.keys(window.filterLogos.team).map(h => [h, 1]))
        : {};
      const teams = Object.keys(facetTeams).length ? facetTeams : logoTeams;

      // Already rendered — just sync checked states
      if (list.querySelector('input[data-teams-drawer-cb]')) {
        const activeSet = new Set(this._getActiveTeamHandles());
        list.querySelectorAll('input[data-teams-drawer-cb]').forEach(cb => {
          cb.checked = activeSet.has(cb.value);
        });
        return;
      }
      const sorted = Object.keys(teams).sort((a, b) => a.localeCompare(b));
      const activeSet = new Set(this._getActiveTeamHandles());
      const toHandle = v => v.toLowerCase().replaceAll(' ', '-');
      const favTeams = (() => {
        try { return new Set(JSON.parse(document.querySelector('[data-fav-teams]')?.dataset.favTeams || '[]')); }
        catch { return new Set(); }
      })();

      list.innerHTML = sorted.map(value => {
        const handle   = toHandle(value);
        const label    = this.toTitleCase(this.formatLabel(value));
        const src      = window.filterLogos?.team?.[handle];
        if (src === null) return ''; // confirmed no logo — skip upfront
        const isActive = activeSet.has(handle);
        const cbId     = `teams-drawer-cb-${handle}`;
        const logoEl   = src
          ? `<img src="${src}" alt="" aria-hidden="true" class="w-6 h-6 object-contain shrink-0">`
          : `<span class="block w-6 h-6 shrink-0" data-logo-handle="${handle}" data-logo-type="team" data-logo-size="w-6 h-6"></span>`;

        return `<li>
          <input type="checkbox" id="${cbId}" value="${handle}"${isActive ? ' checked' : ''} data-teams-drawer-cb>
          <label for="${cbId}" data-team-label="${label}">
            ${logoEl}
            <span>${label}</span>
            ${favTeams.has(handle) ? `<span class="ml-auto w-4 h-4 shrink-0 text-primary-dark" aria-label="Favorite team"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 14 15" fill="currentColor"><path d="M12 1V13L7.28497 10.3246L7 10.1593L6.71503 10.3246L2 13V1H12Z"/></svg></span>` : ''}
          </label>
        </li>`;
      }).join('');

      const loading = list.querySelector('[data-teams-drawer-loading]');
      if (loading) loading.remove();

      this.hydrateLogos();
    }

    renderFilters(filtersInput) {
      let filters = filtersInput;
      if (!filters) return;

      // Build cache of all facet values pre-filtering
      if (!this._facetCache) this._facetCache = {};
      Object.keys(filters).forEach(facet => {
        if (!this._facetCache[facet]) this._facetCache[facet] = {};
        Object.assign(this._facetCache[facet], filters[facet]);
      });

      const filtersWraps = document.querySelectorAll('[data-filters-wrap]');

      // Save scroll positions before re-render (keyed by selector, not element ref)
      const drawerScrollTop = document.querySelector('.collection-filters')?.scrollTop ?? 0;
      const teamListScrollTop = document.querySelector('[data-filter-name="named_tags.team"]')?.scrollTop ?? 0;

      this._filterSearchParams = new URLSearchParams(window.location.search);
      this._decodedFilterString = decodeURI(this._filterSearchParams.get('filters') || '');

      // Compute conditions for dynamic facets
      const _filterStr = this._decodedFilterString || '';
      const _handle = this.collectionHandle?.toLowerCase() || '';
      const showDriverFilter = _handle.includes('nascar') || _filterStr.includes(':"nascar"');
      const showBreedFilter  = _handle.includes('dog') || _filterStr.includes('named_tags.breed:"') || _filterStr.includes(':"dogs"');

      // Merge cached facet keys so filtered-on facets (excluded from Algolia response) still render
      const allFacetKeys = [...new Set([
        ...Object.keys(this._facetCache || {}),
        ...Object.keys(filters),
        ...(showDriverFilter ? ['named_tags.driver'] : []),
        ...(showBreedFilter  ? ['named_tags.breed']  : []),
      ])]
        .filter(k => {
          if (k === 'named_tags.driver') return showDriverFilter;
          if (k === 'named_tags.breed')  return showBreedFilter;
          return true;
        })
        .sort((a, b) => {
          const ai = this.facetsOrder.indexOf(a);
          const bi = this.facetsOrder.indexOf(b);
          if (ai === -1 && bi === -1) return 0;
          if (ai === -1) return 1;
          if (bi === -1) return -1;
          return ai - bi;
        });

      filtersWraps.forEach((filterWrap, i) => {
        filterWrap.innerHTML = `
          <content-accordion data-allow-multiple-active="true">
            <ul>
              ${allFacetKeys.map((filter) => {
                if (this.facetsExcludedFromDisplay.includes(filter) || this.facetPrefixesExcludedFromDisplay.find((prefix => filter.includes(prefix)))) return;

                const filterValues = Object.keys(filters[filter] || this._facetCache?.[filter] || {});

                if (filter.includes('option_names') || filter.includes('named_tags_names')) {
                  let key = filter.replace('_names', '');
                  if (key.slice(-1) !== 's') {
                    key = key.concat('s');
                  }

                  return this.renderFilterGroupFromParentObj({
                    key,
                    filters: filters,
                    filterValues: filterValues
                  });
                }

                return this.renderFilterList(filter, filterValues, filter);
              }).join('')}
            </ul>
          </content-accordion>
        `;
      });

      // Restore scroll positions on newly rendered elements
      if (drawerScrollTop) {
        const drawer = document.querySelector('.collection-filters');
        if (drawer) drawer.scrollTop = drawerScrollTop;
      }
      if (teamListScrollTop) {
        const teamList = document.querySelector('[data-filter-name="named_tags.team"]');
        if (teamList) teamList.scrollTop = teamListScrollTop;
      }

      // Restore team search input and visibility after re-render
      const newInput = document.querySelector('[data-team-search]');
      if (newInput) newInput.value = this._teamSearchTerm || '';
      this._applyTeamSearch();
    }

    _applyTeamSearch() {
      const term = this._teamSearchTerm || '';
      const group = document.querySelector('[data-algolia-filter-group="named_tags.team"]');
      if (!group) return;
      let anyVisible = false;
      group.querySelectorAll('li').forEach(item => {
        const visible = !term || item.textContent.toLowerCase().includes(term);
        item.style.display = visible ? '' : 'none';
        if (visible) anyVisible = true;
      });
      let emptyEl = group.querySelector('[data-team-search-empty]');
      if (!anyVisible && term) {
        if (!emptyEl) {
          emptyEl = document.createElement('li');
          emptyEl.dataset.teamSearchEmpty = '';
          emptyEl.className = 'text-xs text-dove-grey py-3 text-center';
          emptyEl.textContent = 'No teams match your search';
          group.appendChild(emptyEl);
        }
        emptyEl.hidden = false;
      } else if (emptyEl) {
        emptyEl.hidden = true;
      }
      const teamContent = document.querySelector('[data-accordion-id="named_tags.team"] [data-accordion-content]');
      if (teamContent) {
        teamContent.style.setProperty('--accordion-content-height', `${teamContent.scrollHeight}px`);
      }
    }

    applyTitleReplacements(str) {
      if (!window.titleReplacements) return str;
      return window.titleReplacements.split('\n').reduce((out, line) => {
        const [find, replace] = line.trim().split('|');
        if (!find || !replace) return out;
        return out.replace(new RegExp(find.trim(), 'gi'), replace.trim());
      }, str);
    }

    formatLabel(label) {
      const newLabel = label.replaceAll('options.', '').replaceAll('named_tags.', '').replaceAll('_', ' ').replaceAll('-', ' ');
      return this.labelOverrides.get(newLabel.trim().toLowerCase()) ?? newLabel;
    }
    
    renderFilterGroupFromParentObj({ key, filters, filterValues}) {
      return filterValues.map((optionFilterName) => {
        const filter = `${key}.${optionFilterName}`;
        if (this.facetsExcludedFromDisplay.includes(filter)) return;
        if (!filters[filter]) return;
        
        const subFilterValues = Object.keys(filters[filter]);
        if (!subFilterValues) return;
        
        return this.renderFilterList(optionFilterName, subFilterValues, `${key}.${optionFilterName}`);
      }).join('');
    }
    
    renderFilterRemovalButtons() {
      const filterRemovalButtonsWrap = document.querySelectorAll('[data-remove-filters]');
      if (!filterRemovalButtonsWrap.length) return;

      // Parse URL for remove buttons
      const filterString = decodeURI(new URLSearchParams(window.location.search).get('filters') || '');
      const appliedValues = [...filterString.matchAll(/(\S+?):"([^"]+)"/g)]
        .map(([, category, value]) => ({ category: category.replace(/^\(+/, ''), value }))
        .filter(({ category }) =>
          category !== 'collections' &&
          !category.startsWith('NOT')
        );

      filterRemovalButtonsWrap.forEach(el => el.innerHTML = '');

      const count = appliedValues.length;
      document.querySelectorAll('[data-filter-label]').forEach(el => {
        el.textContent = count > 0 ? `Filter + Sort [${count}]` : `Filter + Sort`;
      });

      if (!count) {
        document.querySelector('[data-mobile-clear-all]')?.classList.add('hidden');
        return;
      }

      appliedValues.forEach(({ category, value }) => {
        filterRemovalButtonsWrap.forEach(el => el.insertAdjacentHTML('beforeend', `
          <button
            title="Remove ${this.formatLabel(category)} ${this.formatLabel(value)} filter"
            data-filter-action="remove-algolia-filter"
            data-category="${category}"
            class="inline-flex items-center gap-1.5 pr-3 md:px-2 text-xs hover:border-primary-dark transition cursor-pointer [&_span]:text-dove-grey [&_svg]:text-primary-dark"
            data-remove-value="${value}"
          >
            <span>${category === 'named_tags.league' ? this.formatLabel(value).toUpperCase() : category === 'options.size' ? (() => { const l = this.formatLabel(value); const sizeWords = ['kid', 'youth']; return l.length <= 3 && !sizeWords.includes(l.toLowerCase()) ? l.toUpperCase() : this.toTitleCase(l); })() : this.toTitleCase(this.formatLabel(value))}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <path d="M0.265137 0.265137L3.76514 3.76514M3.76514 3.76514L0.265137 7.26514M3.76514 3.76514L7.26514 7.26514M3.76514 3.76514L7.26514 0.265137" stroke="currentColor" stroke-width="0.75"/>
            </svg>
          </button>
        `));
      });

      const mobileClearAllButton = document.querySelector('[data-mobile-clear-all]');
      if (mobileClearAllButton) {
        mobileClearAllButton.classList.remove('hidden');
        mobileClearAllButton.classList.add('inline-block');
      }
    }
    
    renderFilterList(filterName, subValuesUnsorted, id) {
      const cachedValues = this._facetCache?.[id] ? Object.keys(this._facetCache[id]) : [];
      const availableSet = new Set(subValuesUnsorted.map(v => v.toLowerCase()));
      const filterString = this._decodedFilterString ?? decodeURI((this._filterSearchParams || new URLSearchParams(window.location.search)).get('filters') || '');
      const facetHasActiveFilter = filterString.includes(`${id}:"`);
      const merged = [...new Set([...subValuesUnsorted, ...cachedValues])];

      // Skip groups with only one visible option — use cached normalized Set per facet
      if (!this._excludedSets) this._excludedSets = new Map();
      if (!this._excludedSets.has(filterName)) {
        this._excludedSets.set(filterName, new Set((this.facetsValuesExcludedFromDisplay[filterName] || []).map(x => x.toLowerCase())));
      }
      const excluded = this._excludedSets.get(filterName);
      const visibleCount = merged.filter(v => !excluded.has(v.toLowerCase())).length;
      if (visibleCount <= 1) return '';

      let subValues = filterName === 'options.size'
        ? [...merged].filter(v => !/^\d+(\.\d+)?$/.test(v)).sort((a, b) => {
            const ai = this.sizeOrder.indexOf(a.toLowerCase());
            const bi = this.sizeOrder.indexOf(b.toLowerCase());
            if (ai === -1 && bi === -1) return a.localeCompare(b);
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
          })
        : filterName === 'named_tags.league'
        ? [...merged].sort((a, b) => {
            const leagueOrder = ['mlb', 'nfl', 'nba', 'nhl', 'ncaa', 'milb', 'mls', 'nascar', 'wnba'];
            const ai = leagueOrder.indexOf(a.toLowerCase());
            const bi = leagueOrder.indexOf(b.toLowerCase());
            if (ai === -1 && bi === -1) return a.localeCompare(b);
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
          })
        : customSort(merged);
        
      let label;
      if (filterName.includes('color-group')) {
        label = 'Color';
      } else {
        label = this.formatLabel(filterName);
      }
    
      const isTeam = filterName === 'named_tags.team';
      const teamIsActive = isTeam && facetHasActiveFilter;
      const leagueIsActive = filterString.includes('named_tags.league:"');

      const itemsHtml = subValues.map((value, i) => {
        if (excluded.has(value.toLowerCase())) return '';
        if (document.querySelector(`.finder__item [value="${value}"][data-filter-action="algolia-filter-change"]:checked`)) return '';
        const _toHandle = v => v.toLowerCase().replaceAll(' ', '-');
        const _filterVal = (isTeam || filterName === 'named_tags.league' || filterName === 'named_tags.driver' || filterName === 'named_tags.breed') ? _toHandle(value) : value;
        const isChecked = filterString.includes(`${id}:"${_filterVal}"`);
        if (teamIsActive && !isChecked) return '';
        if ((!isTeam || leagueIsActive) && !availableSet.has(value.toLowerCase()) && !isChecked) return '';
        const cbHtml = this.renderCheckbox({
          value,
          category: filterName,
          label: this.formatLabel(value),
          id: `filter-value-${value}-${i}`,
          swatch: filterName.includes('color'),
          formatAsPrice: filterName.toLowerCase()?.includes('price'),
        });
        if (cbHtml === null) return '';
        return `<li class="filter-list-item ${value}">${cbHtml}</li>`;
      }).join('');

      if (!itemsHtml.trim()) return '';

      return window.renderAccordionItem({
        isOpenByDefault: !!document.querySelector(`[data-accordion-id="${id}"].active`),
        label: label,
        extraClass: 'border-primary-dark/20',
        contentClass: isTeam && !teamIsActive ? 'pb-0' : 'pb-5',
        content: `
          ${isTeam && !teamIsActive ? `
          <div class="filter-search relative bg-primary-light border border-secondary-dark mb-4">
            <input data-team-search placeholder="Search" type="text" aria-label="Search Teams" class="w-full p-2 pl-3 pr-8 text-sm placeholder:text-dove-grey text-primary-dark">
            <span class="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-dove-grey pointer-events-none" data-team-search-icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20"><path d="m20 18.868-6.489-6.5a7.592 7.592 0 1 0-1.127 1.136L18.869 20zM7.6 13.613a6.005 6.005 0 1 1 6-6.006 6.008 6.008 0 0 1-6 6.005z"/></svg>
            </span>
            <button type="button" data-team-search-clear aria-label="Clear search" class="absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 items-center justify-center text-secondary-dark hover:text-primary-dark hidden">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 8 8" fill="none"><path d="M0.265 0.265L3.765 3.765M3.765 3.765L0.265 7.265M3.765 3.765L7.265 7.265M3.765 3.765L7.265 0.265" stroke="currentColor" stroke-width="1.2"/></svg>
            </button>
          </div>` : ``
          }
          <ul data-algolia-filter-group="${id}" data-filter-name="${filterName}" class="filter-list filter-list-${filterName}${isTeam && !teamIsActive ? ' max-h-64 overflow-y-auto' : ''}">
            ${itemsHtml}
          </ul>
        `,
        id,
      });
    }
    
    
    toTitleCase(str) {
      return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
    }

    renderCheckbox = ({ label, value, id, swatch, formatAsPrice, category }) => {
      const HANDLE_CATEGORIES = new Set(['named_tags.team', 'named_tags.league', 'named_tags.driver', 'named_tags.breed']);
      const LOGO_TYPE_MAP = {
        'named_tags.team':   'team',
        'named_tags.league': 'league',
        'named_tags.driver': 'driver',
        'named_tags.breed':  'breed',
      };

      if (category === 'named_tags.team') {
        label = this.toTitleCase(label);
        const override = window.filterLogos?.teamOverrides?.[value.toLowerCase().replaceAll(' ', '-')];
        if (override) label = label.replace(new RegExp(override, 'i'), override);
      } else if (category === 'named_tags.league') {
        label = label.toUpperCase();
      } else if (category === 'options.size') {
        const sizeWords = ['kid', 'youth'];
        label = label.length <= 3 && !sizeWords.includes(label.toLowerCase()) ? label.toUpperCase() : this.toTitleCase(label);
      } else {
        label = this.applyTitleReplacements(this.toTitleCase(label));
      }
      const toHandle = v => v.toLowerCase().replaceAll(' ', '-');
      const filterVal = HANDLE_CATEGORIES.has(category) ? toHandle(value) : value;
      const filterString = this._decodedFilterString ?? decodeURI((this._filterSearchParams || new URLSearchParams(window.location.search)).get('filters') || '');
      const isChecked = filterString.includes(`${category}:"${filterVal}"`);

      const logoType = LOGO_TYPE_MAP[category];
      let logoEl = '';
      if (logoType) {
        const handle = toHandle(value);
        const logoStore = window.filterLogos?.[logoType]; // null = not configured, {} = configured but empty, {h:url} = has logos
        const src = logoStore?.[handle];
        if (window.filterLogos && logoStore != null && src == null) return null; // logos loaded for this type, none found — skip
        if (logoStore != null) {
          logoEl = src
            ? `<img src="${src}" alt="" aria-hidden="true" class="w-6 h-6 object-contain shrink-0">`
            : `<span class="block w-4 h-4 shrink-0" data-logo-handle="${handle}" data-logo-type="${logoType}"></span>`;
        }
      }

      const inputValue = HANDLE_CATEGORIES.has(category) ? toHandle(value) : value;
      return `
        <input title="${label}" ${isChecked ? 'checked' : ''} id="${id}" type="checkbox" value="${inputValue}" data-filter-action="algolia-filter-change" data-filter="${category}:${inputValue}">
        <label for="${id}">
          ${swatch ? `<div class="w-4 h-4 rounded-full border border-primary-dark/20 filter__swatch swatch--${label.toLowerCase().trim().replaceAll(' ', '-')}"></div>` : ''}
          ${logoEl}
          <span>${formatAsPrice ? `$${label.replaceAll(':', ' - $')}` : label}</span>
        </label>
      `;
    }
    
    getInGridData() {
      if (this._inGridData !== undefined) return this._inGridData;
      const scriptEl = document.querySelector('[data-in-grids]');
      if (!scriptEl) { this._inGridData = null; return null; }
      try {
        this._inGridData = JSON.parse(scriptEl.textContent);
      } catch {
        this._inGridData = null;
      }
      return this._inGridData;
    }


    getCampaignData() {
      if (this._campaignData !== undefined) return this._campaignData;
      const scriptEl = this.querySelector('[data-metaobject-ingrids]');
      if (!scriptEl) { this._campaignData = null; return null; }
      try {
        this._campaignData = JSON.parse(scriptEl.textContent);
      } catch {
        this._campaignData = null;
      }
      return this._campaignData;
    }

    renderProducts(products, replace = true, banners = false) {
      window.dispatchEvent(new CustomEvent('algolia:productsViewed', {
        detail: {
          products
        }
      }));

      const productsWrap = this.querySelector('[data-product-grid]');
      if (!productsWrap) return;

      if (!products.length) {
        productsWrap.innerHTML = `
          <div class="no-results">
            <h3>No products match your query. Adjust your filters and try again.</h3>
          </div>
        `;
      };

      if (replace) {
        this.totalProductsShown = 0;
        productsWrap.innerHTML = '';
      }

      const campaignData = this.getCampaignData();
      const campaignMediaList = campaignData?.collection_media_list;
      const mediaPosition = campaignData?.collection_media_position ?? 1;
      const startingPosition = campaignData?.campaign_starting_position ?? 1;

      const inGrids = (this.getInGridData() || []).slice().sort((a, b) => a.position - b.position);
      if (replace) this._placedInGrids = new Set();

      products.forEach((product, index) => {
        if ((index) >= (this.productsPerPage - this.offset)) {
          return;
        }

        if (banners) {
          banners.forEach((banner) => {
            const hasSeparateMobilePos = banner.mobile_position && banner.mobile_position !== banner.position;

            // Desktop position
            if (banner.position - 1 == this.totalProductsShown) {
              this.renderBanner(banner, hasSeparateMobilePos ? 'desktop' : 'both');
              this.offset += 1;
            }

            // Mobile position — only rendered when it differs from desktop
            if (hasSeparateMobilePos && banner.mobile_position - 1 == this.totalProductsShown) {
              this.renderBanner(banner, 'mobile');
              this.offset += 1;
            }
          });
        }

        if (campaignMediaList?.length) {
          const productIndex = this.totalProductsShown + 1; 
          if (productIndex >= startingPosition) {
            const adjusted = productIndex - startingPosition;
            if (adjusted % mediaPosition === 0) {
              const mediaIdx = Math.floor(adjusted / mediaPosition) % campaignMediaList.length;
              this.renderCampaignTile(campaignMediaList[mediaIdx]);
            }
          }
        }

        // Inject in-grid tiles whose position matches the current slot
        const isMobile = window.innerWidth < 768;
        inGrids.forEach(tile => {
          const activePos = isMobile ? (tile.mobile_position ?? tile.position) : tile.position;
          const key = `${tile.handle}-${activePos}`;
          if (activePos - 1 === this.totalProductsShown && !this._placedInGrids?.has(key)) {
            this._placedInGrids.add(key);
            this.renderInGridTile(tile);
          }
        });

        this.totalProductsShown += 1;
        productsWrap.insertAdjacentHTML(
          'beforeend',
          `<intersection-loader
            data-object-id="${product.objectID}"
            data-position="${product.position}"
            data-url="${this.locale ? `/${this.locale}` : `` }${this.collectionHandle ? `/collections/${this.collectionHandle}`: ''}/products/${product.handle}"
            data-section-id="product-card"
            data-extra="position:${product.position},object-id:${product.objectID}"
            data-root-margin="400px"
          ></intersection-loader>`
        )
      });
    }

    renderInGridTile({ handle }) {
      const productsWrap = this.querySelector('[data-product-grid]');
      if (!productsWrap) return;

      const staging = document.querySelector('[data-in-grid-staging]');
      const source  = staging?.querySelector(`[data-in-grid-handle="${handle}"]`);
      if (!source) return;

      productsWrap.appendChild(source.cloneNode(true));
    }

    reinsertInGridTiles() {
      const grid = this.querySelector('[data-product-grid]');
      const inGrids = this.getInGridData();
      if (!grid || !inGrids?.length) return;

      // Remove existing tiles
      grid.querySelectorAll('.in-grid-tile').forEach(el => el.remove());
      this._placedInGrids = new Set();

      const isMobile = window.innerWidth < 768;
      const sorted = inGrids.slice().sort((a, b) => {
        const ap = isMobile ? (a.mobile_position ?? a.position) : a.position;
        const bp = isMobile ? (b.mobile_position ?? b.position) : b.position;
        return ap - bp;
      });

      const staging = document.querySelector('[data-in-grid-staging]');
      // Walk product nodes, insert tiles at correct positions
      const productNodes = Array.from(grid.children);
      let productCount = 0;

      for (let i = 0; i <= productNodes.length; i++) {
        sorted.forEach(tile => {
          const activePos = isMobile ? (tile.mobile_position ?? tile.position) : tile.position;
          const key = `${tile.handle}-${activePos}`;
          if (activePos - 1 === productCount && !this._placedInGrids.has(key)) {
            this._placedInGrids.add(key);
            const source = staging?.querySelector(`[data-in-grid-handle="${tile.handle}"]`);
            if (!source) return;
            const clone = source.cloneNode(true);
            if (productNodes[i]) {
              grid.insertBefore(clone, productNodes[i]);
            } else {
              grid.appendChild(clone);
            }
          }
        });
        productCount++;
      }
    }

    renderCampaignTile({ html }) {
      const productsWrap = this.querySelector('[data-product-grid]');
      if (!productsWrap || !html) return;

      productsWrap.insertAdjacentHTML(
        'beforeend',
        `<div class="product-grid__item product-grid__item--campaign active">
          <div class="grid__item__image">
            ${html}
          </div>
        </div>`
      );
    }

    async loadFilterLogos() {
      if (window.filterLogos) return;
      if (this._filterLogosPromise) return this._filterLogosPromise;
      this._filterLogosPromise = (async () => {
        const teamsIndex   = this.dataset.teamsIndex;
        const leaguesIndex = this.dataset.leaguesIndex;
        const driversIndex = this.dataset.driversIndex;
        const breedsIndex  = this.dataset.breedsIndex;
        const appId = this.dataset.appId;
        const apiKey = this.dataset.apiKey;
        if (!teamsIndex) { window.filterLogos = { team: {}, league: {}, driver: null, breed: null }; return; }

        try {
          const requests = [
            { indexName: teamsIndex, query: '', params: `hitsPerPage=1000&attributesToRetrieve=objectID,logo,override&filters=${encodeURIComponent('published:true')}` },
          ];
          if (leaguesIndex) requests.push({ indexName: leaguesIndex, query: '', params: 'hitsPerPage=200&attributesToRetrieve=objectID,logo' });
          if (driversIndex) requests.push({ indexName: driversIndex, query: '', params: 'hitsPerPage=200&attributesToRetrieve=objectID,logo' });
          if (breedsIndex)  requests.push({ indexName: breedsIndex,  query: '', params: 'hitsPerPage=200&attributesToRetrieve=objectID,logo' });

          const res = await fetch(`https://${appId}-dsn.algolia.net/1/indexes/*/queries`, {
            method: 'POST',
            headers: {
              'X-Algolia-Application-Id': appId,
              'X-Algolia-API-Key': apiKey,
            },
            body: JSON.stringify({ requests }),
          });
          const { results } = await res.json();

          const toHandle = id => id.replace(/^team_|^league_|^driver_|^breed_/, '').replaceAll('_', '-');

          const teamHits = results[0]?.hits ?? [];
          let rIdx = 1;
          const leagueHits = leaguesIndex ? (results[rIdx++]?.hits ?? []) : [];
          const driverHits = driversIndex ? (results[rIdx++]?.hits ?? []) : [];
          const breedHits  = breedsIndex  ? (results[rIdx++]?.hits ?? []) : [];

          window.filterLogos = {
            team:   Object.fromEntries(teamHits.filter(h => h.logo).map(h => [toHandle(h.objectID), h.logo])),
            league: Object.fromEntries(leagueHits.filter(h => h.logo).map(h => [toHandle(h.objectID), h.logo])),
            driver: driversIndex ? Object.fromEntries(driverHits.filter(h => h.logo).map(h => [toHandle(h.objectID), h.logo])) : null,
            breed:  breedsIndex  ? Object.fromEntries(breedHits.filter(h => h.logo).map(h => [toHandle(h.objectID), h.logo]))  : null,
            teamOverrides: Object.fromEntries(teamHits.filter(h => h.override).map(h => [toHandle(h.objectID), h.override])),
          };
        } catch {
          window.filterLogos = { team: {}, league: {}, driver: null, breed: null };
        }
      })();
      return this._filterLogosPromise;
    }

    hydrateLogos() {
      const placeholders = document.querySelectorAll('[data-logo-handle]');
      if (!placeholders.length) return;

      if (!this._logoFetching) this._logoFetching = new Set();

      const toFetch = [];

      placeholders.forEach(span => {
        const { logoHandle: handle, logoType: type } = span.dataset;
        const sizeClass = span.dataset.logoSize || 'w-4 h-4';
        const cached = window.filterLogos?.[type]?.[handle];

        if (cached) {
          span.outerHTML = `<img src="${cached}" alt="" aria-hidden="true" class="${sizeClass} object-contain shrink-0">`;
          return;
        }

        const key = `${type}:${handle}`;
        if (this._logoFetching.has(key)) return; // fetch already in-flight; will update all matching spans on resolve
        this._logoFetching.add(key);
        toFetch.push({ type, handle, key });
      });

      if (toFetch.length) this._fetchLogosBatch(toFetch);
    }

    async _fetchLogosBatch(entries) {
      if (!window.filterLogos) window.filterLogos = { team: {}, league: {}, driver: null, breed: null };

      if (!this.shop || !this.token) {
        entries.forEach(({ key }) => this._logoFetching.delete(key));
        return;
      }

      const metaobjectTypeMap = { team: 'sparky--team', league: 'sparky--league', driver: 'sparky--driver', breed: 'sparky--breed' };
      const query = `query FilterLogos {
        ${entries.map((e, i) => `l${i}: metaobject(handle: {type: "${metaobjectTypeMap[e.type] ?? metaobjectTypeMap.team}", handle: ${JSON.stringify(e.handle)}}) {
          field(key: "logo") { reference { ... on MediaImage { image { url(transform: { maxWidth: 32 }) } } } }
        }`).join('\n')}
      }`;

      try {
        const res = await fetch(`https://${this.shop}/api/2024-10/graphql.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': this.token },
          body: JSON.stringify({ query }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const { data, errors } = await res.json();
        if (errors?.length) throw new Error(errors[0].message);

        entries.forEach(({ type, handle }, i) => {
          const src = data?.[`l${i}`]?.field?.reference?.image?.url ?? null;
          if (!window.filterLogos[type]) window.filterLogos[type] = {};
          window.filterLogos[type][handle] = src;

          const matches = document.querySelectorAll(`[data-logo-handle="${handle}"][data-logo-type="${type}"]`);
          if (src) {
            matches.forEach(el => { el.outerHTML = `<img src="${src}" alt="" aria-hidden="true" class="${el.dataset.logoSize || 'w-4 h-4'} object-contain shrink-0">`; });
          } else {
            matches.forEach(el => el.closest('li')?.remove());
          }
        });
      } catch {
        // leave placeholders as-is; a later hydrateLogos() pass may retry
      } finally {
        entries.forEach(({ key }) => this._logoFetching.delete(key));
      }
    }

    _syncFinderSelection() {
      if (!this.appliedFilters) return;
      document.querySelectorAll('[data-product-finder] input[data-filter]').forEach(input => {
        const colonIdx = input.dataset.filter.indexOf(':');
        if (colonIdx === -1) return;
        const group = 'named_tags.' + input.dataset.filter.slice(0, colonIdx);
        const value = input.dataset.filter.slice(colonIdx + 1);
        if (this.appliedFilters.includes(`${group}:"${value}"`)) {
          input.checked = true;
        }
      });
    }

    filterProductFinder(facets) {
      const finder = document.querySelector('[data-product-finder]');
      if (!finder) return;
      if (this._finderReady) return;
      // Not base state (e.g. page refreshed with filter in URL) — fetch base facets first.
      if (this.appliedFilters !== this.buildBaseFilter()) {
        this._finderReady = true;
        this.algoliaClient.search({
          requests: [{
            indexName: this.currentIndex,
            facets: ['named_tags.*'],
            filters: this.buildBaseFilter(),
            length: 0,
            offset: 0
          }]
        }).then(res => {
          this._applyFinderTileVisibility(finder, res.results[0]?.facets || {});
        }).catch(() => {
          finder.style.opacity = '1';
        });
        return;
      }
      this._applyFinderTileVisibility(finder, facets);
    }

    _applyFinderTileVisibility(finder, facets) {
      finder.querySelectorAll('swiper-slide:not(:first-child)').forEach(slide => {
        const label = slide.querySelector('[data-algolia-filter]');
        if (!label) return;
        const raw = label.dataset.algoliaFilter;
        const colonIdx = raw.indexOf(':');
        const group = colonIdx !== -1 ? 'named_tags.' + raw.slice(0, colonIdx) : label.dataset.filterName;
        const value = colonIdx !== -1 ? raw.slice(colonIdx + 1) : raw;
        if (!group || !value) { slide.style.display = 'none'; return; }
        const groupFacets = facets[group];
        const valueLower = value.toLowerCase();
        const exists = groupFacets && Object.keys(groupFacets).some(k => k.toLowerCase() === valueLower);
        slide.style.display = exists ? '' : 'none';
      });
      this._finderReady = true;
      finder.style.opacity = '1';
    }

    initBannerDebugPanel() {
      if (new URLSearchParams(window.location.search).get('banner_debug') !== 'true') return;

      // Dynamically load the debug panel utility — only when banner_debug=true
      // Derives the asset base URL from this script's own src so it works on any Shopify CDN
      const thisScript = document.querySelector('script[src*="product-list"]');
      const panelSrc   = thisScript?.src.replace('product-list.js', 'banner-debug-panel.js');
      if (!panelSrc) return;

      const script  = document.createElement('script');
      script.src    = panelSrc;
      script.onload = () => document.body.appendChild(document.createElement('banner-debug-panel'));
      document.head.appendChild(script);
    }

    renderBanner(banner, visibility = 'both') {
      const productsWrap = this.querySelector('[data-product-grid]');
      if (!productsWrap) return;

      const { title, image_url, mobile_image_url, url, video_url, mobile_video_url, colspan, rowspan, mobile_colspan, mobile_rowspan } = banner;
      const hasVideo = video_url || mobile_video_url;
      if (!image_url && !hasVideo) return;

      // Desktop spans (default 1x1)
      const colspanVal = colspan || 1;
      const rowspanVal = rowspan || 1;
      // Mobile spans — fall back to desktop values if not specified
      const mobileColspanVal = mobile_colspan || colspanVal;
      const mobileRowspanVal = mobile_rowspan || rowspanVal;

      const spanStyle = `--colspan:${colspanVal}; --rowspan:${rowspanVal}; --mobile-colspan:${mobileColspanVal}; --mobile-rowspan:${mobileRowspanVal};`;

      let mediaHtml;
      if (hasVideo) {
        const desktopSrc = video_url || mobile_video_url;
        const mobileSrc = mobile_video_url || video_url;
        const hasSeparateMobileVideo = mobile_video_url && mobile_video_url !== video_url;
        mediaHtml = `
          <video
            class="banner-video${hasSeparateMobileVideo ? ' banner-video--desktop' : ''}"
            src="${desktopSrc}"
            autoplay
            muted
            loop
            playsinline
            ${image_url ? `poster="${image_url}"` : ``}
          ></video>
          ${hasSeparateMobileVideo ? `
          <video
            class="banner-video banner-video--mobile"
            src="${mobileSrc}"
            autoplay
            muted
            loop
            playsinline
            ${image_url ? `poster="${image_url}"` : ``}
          ></video>` : ``}
        `;
      } else {
        const hasSeparateMobileImage = mobile_image_url && mobile_image_url !== image_url;
        mediaHtml = hasSeparateMobileImage
          ? `<img src="${image_url}" alt="${title || ''}" loading="lazy" class="banner-image--desktop">
             <img src="${mobile_image_url}" alt="${title || ''}" loading="lazy" class="banner-image--mobile">`
          : `<img src="${image_url}" alt="${title || ''}" loading="lazy">`;
      }

      const visibilityClass = visibility === 'desktop' ? ' product-grid__item--banner--desktop-only'
        : visibility === 'mobile'  ? ' product-grid__item--banner--mobile-only'
        : '';

      productsWrap.insertAdjacentHTML(
        'beforeend',
        `<div class="product-grid__tile product-grid__item product-grid__item--banner${visibilityClass} js-grid-item active" style="${spanStyle}" data-rowspan="${rowspanVal}" data-colspan="${colspanVal}" data-mobile-rowspan="${mobileRowspanVal}" data-mobile-colspan="${mobileColspanVal}">
          <div class="grid__item__image">
            ${url ? `<a href="${url}">` : ``}
              ${mediaHtml}
            ${url ? `</a>` : ``}
          </div>
          ${title ? `
            <div class="grid__item__info">
              <h3>${url ? `<a href="${url}">` : ``}${title}${url ? `</a>` : ``}</h3>
            </div>
          ` : ``}
        </div>`
      )
    }
    
    paginate() {          
      const productsWrap = this.querySelector('[data-product-grid]');
      if (!productsWrap) return;
      const loadingButtons = this.querySelectorAll('[data-filter-action="pagination-next"]');
      
      loadingButtons.forEach(el => el.classList.add('loading'));
      this.page += 1;
      const searchParams = new URL(window.location.href)?.searchParams;
      searchParams.set('page', this.page);
      history.replaceState(`Filtered Collection - ${this.collectionHandle}`, '', `?${searchParams.toString()}`);
      this.fetchFilteredResults(false, true, false);
      loadingButtons.forEach(el => el.classList.remove('loading'));
    }
  }
  
  customElements.define('product-list', ProductList);
}